module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("A chilling tale of African drums and human souls from #1 international bestselling author Kevin J. Anderson and legendary Rush lyricist and drummer Neil Peart.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Early in their three decades of correspondence, Neil Peart sent Kevin J. Anderson extensive descriptions and travelogues of his adventures bicycling solo across Africa. Peart painted a vivid and unsettling landscape as memorable as the lyrics to his songs.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anderson, award-winning and bestselling fantasy and science fiction author, used those descriptions as the backdrop for plotting an intense, atmospheric dark fantasy story that followed Peart’s experiences, though with a much more ominous twist. The two used their respective strengths to weave a memorable tale that will linger long after the last page.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This special illustrated edition includes Anderson’s new introduction, written after Peart’s death on January 7, 2020, as well as the original Afterword Peart wrote for the story.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c66eb9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/book-description.vue
// module id = 63
// module chunks = 0